<template>
  <div class="header">
    <span class="logo"><AppIcon :name="logoName" size="headline-s" /></span>
    <h5>
      {{ title }}
    </h5>
    <template v-if="dateTime">
      <span class="timer-separator">|</span>
      <p>{{ getCurrentTime(dateTime) }}</p>
    </template>
    <div class="actions" v-if="$slots.actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import { AuthMethods } from '@/models/auth-methods';
import { useAuthStore } from '@/stores/authStore';
import { getCurrentTime } from '@/utils/utils';
import { computed } from 'vue';

interface Props {
  dateTime?: string;
  title: string;
}

defineProps<Props>();

const authStore = useAuthStore();
const logoName = computed(() => {
  return authStore.authMethod === AuthMethods.Spain ? 'logo-es' : 'logo-fr';
});
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: $space-3;
}

.timer-separator {
  margin: 0 $space-2;
}

.logo {
  margin-right: $space-2;
}

.actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: $space-2;
}
</style>
